<template lang="pug">
form.v-form.form(
		ref="form"
		@submit.prevent="submit"
		novalidate
		autocomplete="off")
	v-loader(
		:loading="loading"
		:fullscreen="fullscreenLoader"
		:progress="finalSubmitInProgress ? finalUploadProgress : null"
		:progress-text="finalSubmitInProgress ? finalUploadText : ''")
	.form__upload-progress(v-if="stageUpload.active")
		.form__upload-progress-text {{ stageUploadText }}
		.form__upload-progress-track
			.form__upload-progress-value(:style="{width: `${stageOverallProgress}%`}")
		.form__upload-progress-percent {{ stageOverallProgress }}%
	//template(v-if="form && form.success && form.message")
	//	.form__success-message
	//		v-svg-icon.form__success-message-icon(:icon="form.message?.icon")
	//		h2.form__success-message-text(v-if="form.message.text" ) {{ form.message.text }}

	template(v-if="form && form.errors && form.errors.form && form.errors.form.length")
		.form__form-errors
			template(v-if="Array.isArray(form.errors.form) && form.errors.form.length")
				template(v-for="error in form.errors.form")
					.form__form-error.flc(v-html="error")
			template(v-else)
				.form__form-error.flc(v-html="form.errors.form")

	template(v-if="form && (!form.success || !form.hideFormOnSuccess)")
		.form__header.flc.fcc(v-if="form.title || form.titleNote || form.instruction"
				:class="{'form__header--with-instruction': form.instruction}")
			h2.form__header-title.flc(v-if="form.title") {{form.title}}
			//- инструмент «Инструкция»: кнопка справа от заголовка формы,
			//- данные приходят из PHP (параметр INSTRUCTION_CODE компонента)
			v-instruction.form__header-instruction(v-if="form.instruction" :data-source="form.instruction")
			.form__header-note.flc(v-if="form.titleNote" v-html="form.titleNote")

		.form__main.flc.fcc(v-if="form.tabs && form.tabs.length && form.groups && form.groups.length")
			.form__tabs(v-if="!hiddenTabsPanel && form.tabs.some(t => t.title)")
				template(v-for="(tab, tabIndex) in form.tabs" :key="tab.id || tabIndex")
					.form__tab(v-if="tab.title"
							:class="{'active': tab?.id === this.currentTabId}"
							@click="setCurrentTabId(tab?.id)")
							| {{ tab.title }}
			.form__phone-note(v-if="phoneStepNote" v-html="phoneStepNote")
			.form__code-note(v-if="codeStep")
				.form__code-note-title {{ codeStep.enterCodeText }}
				.form__code-note-sub {{ codeStep.codeSentToText }} {{codeStep.phone}}
				button.form__code-note-change.link(type="button" @click="emitChangeNumber") {{ codeStep.changeNumberText }}
			.form__groups
				template(v-for="(group, groupIndex) in form.groups" :key="group.id || groupIndex")
					template(v-if="group.tabId === this.currentTabId" )
						.form__group(:class="group.className" :style="{width: group.width || null}")
							h3.form__group-title.flc(v-if="group.title") {{group.title}}
							.form__group-body.flc
								.form__fields
									template(v-for="(field, fieldIndex) in form.fields" :key="getFieldRenderKey(field, fieldIndex)")
										template(v-if="field.groupId === group.id")
											.form__field(v-if="field.type !== 'hidden'" :style="{width: field.width || null}")
												v-field(:field="field"
														v-model="field.value"
														:file-state="getFileFieldState(field)"
														:errors="getFieldError(field)"
														@emmitData="emmitData"
														@fileinput="fileInput(field, $event)"
														@fileremove="fileRemove(field, $event)"
														@remove="valueRemove(field, $event)"
														@update:model-value="fieldChanged(field, $event)"
														@request-code="requestCode")

							.form__group-note.flc(v-if="group.note && !hideGroupNote" v-html="group.note")
						.form__group.form__group--alt(v-if="form.requireConfirm && form.requireConfirmText && showConfirm")
							.form__group-body.flc
								.form__fields
									.form__field.form__field--flex
										v-field-tumbler(
												:text="form.requireConfirmText"
												:model-value="confirmed"
												@update:model-value="confirmed = $event")

		.form__main.flc.fcc(v-else-if="form.groups && form.groups.length")
			.form__groups
				template(v-for="(group, groupIndex) in form.groups" :key="group.id || groupIndex")
					.form__group(:class="group.className" :style="{width: group.width || null}")
						h3.form__group-title.flc(v-if="group.title") {{group.title}}
						.form__group-note.flc(v-if="group.note" v-html="group.note")
						.form__group-body.flc
							.form__fields
								template(v-for="(field, fieldIndex) in form.fields" :key="getFieldRenderKey(field, fieldIndex)")
									template(v-if="field.groupId === group.id")
										.form__field(v-if="field.type !== 'hidden'" :style="{width: field.width || null}")
											v-field(:field="field"
													v-model="field.value"
													:file-state="getFileFieldState(field)"
													:errors="getFieldError(field)"
													@emmitData="emmitData"
													@fileinput="fileInput(field, $event)"
													@fileremove="fileRemove(field, $event)"
													@remove="valueRemove(field, $event)"
													@update:model-value="fieldChanged(field, $event)"
													@request-code="requestCode"
													:id="field.code || field.id")
				.form__group.form__group--alt(v-if="form.requireConfirm && form.requireConfirmText")
					.form__group-body.flc
						.form__fields
							.form__field.form__field--flex
								v-field.field--big-checkbox(
										:field="computedConfirmField"
										v-model="confirmValue"
										@update:model-value="confirmed = !confirmed")

		.form__footer.flc(v-if="form.buttons && form.buttons.length")
			.form__actions(v-if="form.buttons")
				template(v-for="(button, buttonIndex) in form.buttons" :key="buttonIndex")
					.form__action
						.form__action-label {{button.label}}
						button.btn.btn--primary.btn--round.form__action-button(:type="button.type || 'submit'"
								:class="button.className || 'btn btn--primary'"
								:disabled="isActionButtonDisabled(button)"
								:data-modal-url="button.modalUrl"
								:data-modal-data="button?.modalData || null")
							| {{submitButtonText || button.text}}
			.form__note(v-if="form.note" v-html="form.note" )
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller';
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	mixins: [
		sourceMixin
	],

	props: {
		mode: {
			type: String,
			default: null
		},

		forcedTabId: {
			type: String,
			default: null
		},

		hiddenTabsPanel: {
			type: Boolean,
			default: false
		},

		showConfirm: {
			type: Boolean,
			default: true
		},

		submitButtonText: {
			type: String,
			default: null
		},

		hideGroupNote: {
			type: Boolean,
			default: false
		},

		// шлёт confirmed=1 на сервер, даже когда чекбокс согласия скрыт
		// (showConfirm=false) — используется на экране "Вход", где само
		// согласие уже было дано один раз при регистрации, но серверная
		// проверка CONFIRM_CHECKBOX в vueForms/class.php общая на весь
		// компонент и требует confirmed на любой сабмит
		forceConfirmed: {
			type: Boolean,
			default: false
		},

		phoneStepNote: {
			type: String,
			default: null
		},

		// {phone} на шаге ввода кода из СМС — показываем над клетками
		// "Введите код из СМС / Отправили его на <номер>" + "Изменить номер"
		codeStep: {
			type: Object,
			default: null
		},

		// Центрировать спиннер сохранения по центру экрана, а не по центру
		// формы (нужно на длинной форме создания объявления, где sticky-лоадер
		// «залипает» вверху блока при скролле ниже).
		fullscreenLoader: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'success',
		'form-submited',
		'request-code',
		'updateTabId',
		'change-number',
		'redirect'
	],

	data() {
		return {
			form: null,
			localFormData: new FormData(),
			modalTimeout: null,
			confirmValue: [],
			confirmed: false,
			savedFileKeys: [],
			currentTabId: null,
			isErrorsFound: false,
			localFiles: {},
			filePreviewStates: {},
			stagedFiles: {},
			uploadQueue: [],
			uploadQueueRunning: false,
			stageUpload: {
				active: false,
				total: 0,
				completed: 0,
				currentName: '',
				currentPercent: 0,
				processing: false
			},
			validationInProgress: false,
			pendingSubmitRequested: false,
			finalSubmitInProgress: false,
			finalUploadProgress: 0,
			finalUploadText: ''
		};
	},

	computed: {
		computedConfirmField() {
			return {
				type: 'check-list',
				value: [],
				label: null,
				options: [
					{
						'value': '1',
						'text': this.form.requireConfirmText
					}
				]
			};
		},
		hasPendingManagedUploads() {
			return Object.values(this.stagedFiles).some(file => ['queued', 'uploading', 'processing'].includes(file.status));
		},
		stageOverallProgress() {
			if (!this.stageUpload.total) return 0;
			const value = ((this.stageUpload.completed + (this.stageUpload.currentPercent / 100)) / this.stageUpload.total) * 100;
			return Math.max(0, Math.min(100, Math.round(value)));
		},
		stageUploadText() {
			const status = this.form?.uploadStatus || {};
			const template = this.stageUpload.processing
				? (status.processing || 'Processing file #CURRENT# of #TOTAL#: #FILE#')
				: (status.uploading || 'Uploading file #CURRENT# of #TOTAL#: #FILE#');
			return this.replaceUploadTokens(template, {
				'#CURRENT#': Math.min(this.stageUpload.completed + 1, this.stageUpload.total),
				'#TOTAL#': this.stageUpload.total,
				'#FILE#': this.stageUpload.currentName
			});
		}
	},
	created() {
	},
	beforeUnmount() {
		Object.values(this.filePreviewStates).forEach((state) => {
			(state?.files || []).forEach((file) => {
				if (file?.objectUrl && file.path && typeof URL !== 'undefined' && URL.revokeObjectURL) {
					URL.revokeObjectURL(file.path);
				}
			});
		});
	},
	watch: {
		isErrorsFound() {
			if(this.isErrorsFound && this.form.errors.fields.length) {
				this.scrollToFirstError()
			}
		},
		form() {
			// при инициализации/перезагрузке формы — подставить название комплекса,
			// если комплекс уже выбран, а поле complex_name пустое
			this.$nextTick(() => this.autofillComplexNameInitial());
		},
		forcedTabId(value) {
			if (value) {
				this.setCurrentTabId(value);
			}
		}
	},

	methods: {
		getFieldRenderKey(field, index) {
			return field?.id || field?.name || field?.code || index;
		},

		getFileStateKey(field) {
			if (!field || field.type !== 'file') return '';
			return String(field.code || field.id || field.name || '');
		},

		prepareFilePreviewStates(data) {
			(data?.fields || []).forEach((field) => {
				const key = this.getFileStateKey(field);
				if (!key) return;
				if (!this.filePreviewStates[key]) {
					this.filePreviewStates[key] = {
						files: [],
						initialized: false,
						mainImageKey: null
					};
				}
			});
		},

		getFileFieldState(field) {
			const key = this.getFileStateKey(field);
			return key ? this.filePreviewStates[key] || null : null;
		},

		requestCode() {
			this.submit({action: 'new-code'});
		},

		emitChangeNumber() {
			this.$emit('change-number');
		},

		getFieldError(field) {
			if (this.form.errors && this.form.errors.fields) {
				let filteredErrors = this.form.errors.fields.filter((item) => item.name === field.name);
				this.isErrorsFound = true
				return filteredErrors.length ? filteredErrors : null;
			} else {
				return null;
			}
		},

		setCurrentTabId(id) {
			this.currentTabId = id;
			this.$emit('updateTabId', this.currentTabId);
		},

		scrollToFirstError() {
			if (!this) {
				return;
			}
			if (document.body.classList.contains('state--modal-open')) {
				return;
			}

			this.$nextTick(() => {
				const $errorFields = this.$refs.form.querySelectorAll('.form-error');
				if ($errorFields.length > 0) {
					const $firstErrorField = $errorFields[0];
					const yOffset = -10;
					const coordY = $firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;
					window.scrollTo({top: coordY, behavior: 'smooth'});
				} else {
					window.scrollTo({top: 0, behavior: 'smooth'});
				}
			})

		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		updateForm() {
			this.submit({action: 'autosubmit'});
			console.log('form-submited')
		},

		dataSet(data, options = {}) {
			if (data?.redirect) {
				this.$emit('redirect');
			}
			this.isErrorsFound = false
			if (options.validationOnly && this.form) {
				this.form.errors = data?.errors || {};
				return;
			}
			this.prepareFilePreviewStates(data);

			if(data?.tabs && data?.tabs.length) {
				const forcedTabExists = this.forcedTabId && data.tabs.some(t => t.id === this.forcedTabId);
				// приоритет у forcedTabId (явный выбор пользователя: клик по
				// вкладке, переключение вход/регистрация, "изменить номер") —
				// серверный activeTabId может нести устаревшую вкладку и не
				// должен перебивать намерение пользователя
				if (forcedTabExists) {
					this.setCurrentTabId(this.forcedTabId);
				} else if(data?.activeTabId) {
					this.setCurrentTabId(data.activeTabId);
				} else {
					this.setCurrentTabId(data.tabs[0]?.id);
				}
			}

			if(data.updateUsers) {
				window.modalController.closeAll();
				controller.updateUsers();
			}

			if(data.updateForm) {
				window.modalController.closeAll();
				controller.updateForm();
			}

			if (data.success && data.closeModal) {
				if (typeof modalController !== 'undefined') {
					if (typeof (data.modalTimeout) !== 'undefined' && data.modalTimeout > 0) {
						clearTimeout(this.modalTimeout);
						this.modalTimeout = setTimeout(() => {
							controller.closeModal();
						}, data.modalTimeout);
					} else {
						controller.closeModal();
					}
				}
				return;
			}
			if (data.modal) {
				window.modalController.closeAll();
				// открыть модальное окно с сообщением об успешной отправке формы
				setTimeout(() => {
					if(data.modal.content) {
						controller.openModal({
							className: data.modal.className,
							content: `<v-modal-window>${data.modal.content}</v-modal-window>`
						});
					} else if(data.modal) {
						controller.openModal({
							...data.modal
						})
					}

				}, 300)

			}
			// раньше эмитилось только при data.updateOut (choice-шаг), из-за
			// чего v-auth.vue держал устаревшую копию data на промежуточных
			// шагах (ввод кода) и его computed (codeField, phoneAction) не
			// видели актуальное состояние. Эмитим на каждом обновлении.
			this.$emit('update-out', data);
			if (data.success && data.message) {
				this.$emit('success',data.message );
			}

			if (data.emit_event) {
				controller.emitCustomEvent(data.emit_event);
			}

			const vip5Prompt = data?.vip5Prompt || null;
			if (vip5Prompt && Array.isArray(data.fields)) {
				const paidField = data.fields.find((field) => field.code === 'PAYED_ITEM');
				if (paidField) {
					// Закрытие окна без согласия должно оставить выбранным TOP.
					paidField.value = vip5Prompt.topValue || {status: '', price: ''};
				}
			}

			this.form = data;
			if (vip5Prompt) {
				this.openVip5Prompt(vip5Prompt);
			}
		},

		openVip5Prompt(prompt) {
			window.modalController.closeAll();
			setTimeout(() => {
				controller.openModal({
					className: 'modal--vip5-confirm',
					component: {
						name: 'v-confirm-modal',
						props: {
							dataSource: {
								variant: 'vip5',
								eyebrow: 'VIP 5',
								title: prompt.title,
								lead: prompt.lead,
								dateLabel: prompt.dateLabel,
								date: prompt.date,
								note: prompt.note,
								buttons: [{
									text: prompt.declineText,
									event: 'reject',
									className: 'btn btn--round'
								}, {
									text: prompt.agreeText,
									event: 'confirm',
									className: 'btn btn--primary btn--round'
								}]
							}
						},
						listeners: {
							confirm: () => {
								const paidField = this.form?.fields?.find((field) => field.code === 'PAYED_ITEM');
								if (paidField) {
									paidField.value = prompt.vipValue;
									this.submit({action: 'vip5-agree', triggerField: paidField.name});
								}
							}
						}
					}
				});
			}, 100);
		},

		emmitData(data) {
		},

		isActionButtonDisabled(button) {
			const confirmationBlocked = this.form?.requireConfirm && this.showConfirm && !this.confirmed;
			return confirmationBlocked || this.finalSubmitInProgress || this.validationInProgress;
		},

		replaceUploadTokens(template, replacements = {}) {
			let result = String(template || '');
			Object.entries(replacements).forEach(([token, value]) => {
				result = result.split(token).join(String(value ?? ''));
			});
			return result;
		},

		notifyUploadError(message) {
			controller.addNotification({
				notificationText: message || this.form?.uploadStatus?.networkError || 'Could not connect to the server.'
			});
		},

		cloneFormData(source, {excludeFiles = false, excludeStageTokens = false} = {}) {
			const clone = new FormData();
			for (const [key, value] of source.entries()) {
				if (excludeFiles && value instanceof Blob) continue;
				if (excludeStageTokens && typeof value === 'string' && value.startsWith('stage:')) continue;
				clone.append(key, value);
			}
			return clone;
		},

		getStagedFileId(fieldName, key) {
			return `${fieldName}:${key}`;
		},

		enqueueManagedUpload(field, file, key) {
			const id = this.getStagedFileId(field.name, key);
			const task = {
				id,
				fieldName: field.name,
				fieldCode: field.code,
				fieldStateKey: this.getFileStateKey(field),
				key,
				file,
				status: 'queued',
				token: '',
				cancelled: false
			};

			this.stagedFiles[id] = task;
			this.uploadQueue.push(task);
			if (!this.stageUpload.active) {
				this.stageUpload.total = 0;
				this.stageUpload.completed = 0;
				this.stageUpload.currentPercent = 0;
			}
			this.stageUpload.active = true;
			this.stageUpload.total += 1;
			this.processManagedUploadQueue();
		},

		async processManagedUploadQueue() {
			if (this.uploadQueueRunning) return;
			this.uploadQueueRunning = true;

			while (this.uploadQueue.length) {
				const task = this.uploadQueue.shift();
				if (!task || task.cancelled) {
					this.stageUpload.completed += 1;
					continue;
				}

				this.stageUpload.currentName = task.file.name || '';
				this.stageUpload.currentPercent = 0;
				this.stageUpload.processing = false;
				task.status = 'uploading';

				try {
					const data = new FormData();
					data.set('state[action]', 'stage-upload');
					data.set('state[fieldCode]', task.fieldCode);
					data.set('sessid', this.form?.sessid || window.BX?.bitrix_sessid?.() || '');
					data.set('bxajaxid', this.form?.bxajaxid || '');
					data.set('upload', task.file, task.file.name);

					const response = await this.requestWithUploadProgress(this.form.remote, data, {
						timeout: 180000,
						onUploadProgress: (progress) => {
							this.stageUpload.currentPercent = Math.min(90, Math.round(progress * .9));
						},
						onUploadComplete: () => {
							task.status = 'processing';
							this.stageUpload.processing = true;
							this.stageUpload.currentPercent = 92;
						}
					});
					if (!response.ok) throw new Error(this.form?.uploadStatus?.networkError || `HTTP ${response.status}`);
					const result = await response.json();
					if (!result?.success || !result?.token) throw new Error(result?.message || this.form?.uploadStatus?.networkError);

					task.token = result.token;
					task.status = 'done';
					this.stageUpload.currentPercent = 100;
					if (task.cancelled) {
						this.releaseStagedUpload(task.token);
					} else {
						this.localFormData.set(`${this.proxyFieldName(task.fieldName)}[${task.key}]`, task.token);
					}
				} catch (error) {
					task.status = task.cancelled ? 'cancelled' : 'failed';
					if (!task.cancelled) {
						const message = error?.message || this.form?.uploadStatus?.networkError;
						this.notifyUploadError(message);
						const previewState = this.filePreviewStates[task.fieldStateKey];
						const preview = previewState?.files?.find(file => file.key === task.key);
						if (preview) {
							if (preview.objectUrl && preview.path && typeof URL !== 'undefined' && URL.revokeObjectURL) {
								URL.revokeObjectURL(preview.path);
							}
							previewState.files.splice(previewState.files.indexOf(preview), 1);
						}
						const currentField = this.form?.fields?.find(field =>
							field.name === task.fieldName || (task.fieldCode && field.code === task.fieldCode));
						if (currentField) {
							currentField.stagedUploadError = {key: task.key, message, nonce: Date.now()};
						}
					}
				} finally {
					this.stageUpload.completed += 1;
					this.stageUpload.processing = false;
					delete task.file;
				}
			}

			this.uploadQueueRunning = false;
			this.stageUpload.currentPercent = 100;
			setTimeout(() => {
				if (!this.hasPendingManagedUploads) this.stageUpload.active = false;
			}, 700);

			if (this.pendingSubmitRequested && !this.validationInProgress) {
				this.pendingSubmitRequested = false;
				this.submit();
			}
		},

		releaseStagedUpload(token) {
			if (!token || !this.form?.remote) return;
			const data = new FormData();
			data.set('state[action]', 'release-staged-upload');
			data.set('state[token]', token);
			data.set('sessid', this.form?.sessid || window.BX?.bitrix_sessid?.() || '');
			data.set('bxajaxid', this.form?.bxajaxid || '');
			fetch(this.form.remote, {method: 'POST', body: data}).catch(() => {});
		},

		responseHasErrors(data) {
			const formErrors = data?.errors?.form;
			const fieldErrors = data?.errors?.fields;
			return (Array.isArray(formErrors) ? formErrors.length > 0 : !!formErrors)
				|| (Array.isArray(fieldErrors) ? fieldErrors.length > 0 : !!fieldErrors);
		},

		plainText(value) {
			const text = String(value || '');
			if (typeof document === 'undefined') {
				return text.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
			}
			const node = document.createElement('div');
			node.innerHTML = text;
			return String(node.textContent || node.innerText || '').replace(/\s+/g, ' ').trim();
		},

		collectErrorMessages(value, result = []) {
			if (Array.isArray(value)) {
				value.forEach(item => this.collectErrorMessages(item, result));
			} else if (value && typeof value === 'object') {
				Object.values(value).forEach(item => this.collectErrorMessages(item, result));
			} else {
				const message = this.plainText(value);
				if (message && !result.includes(message)) result.push(message);
			}
			return result;
		},

		isEmptyRequiredField(field) {
			if (!field) return false;
			if (field.type === 'file') {
				return !(this.getFileFieldState(field)?.files?.length);
			}
			const hasValue = (value) => {
				if (Array.isArray(value)) return value.some(hasValue);
				if (value && typeof value === 'object') return Object.values(value).some(hasValue);
				return value !== null && typeof value !== 'undefined' && String(value).trim() !== '';
			};
			return !hasValue(field.value);
		},

		notifyValidationErrors(data) {
			const errors = Array.isArray(data?.errors?.fields) ? data.errors.fields : [];
			const errorNames = new Set(errors.map(error => String(error?.name || '')).filter(Boolean));
			const fields = Array.isArray(data?.fields) ? data.fields : (this.form?.fields || []);
			const labels = [];
			fields.forEach((field) => {
				if (!field?.required || !errorNames.has(String(field.name || '')) || !this.isEmptyRequiredField(field)) return;
				const label = this.plainText(field.label);
				if (label && !labels.includes(label)) labels.push(label);
			});

			let message = '';
			if (labels.length) {
				message = String(data?.validationSummary || this.form?.validationSummary || 'Complete the required fields: #FIELDS#.')
					.split('#FIELDS#').join(labels.join(', '));
			} else {
				message = this.collectErrorMessages([
					data?.errors?.form,
					errors.map(error => error?.message)
				]).join(' ');
			}
			if (message) controller.addNotification({notificationText: message});
		},

		submit(options = {}) {
			const requestedAction = options.action || 'submit';
			if (requestedAction === 'submit' && (this.finalSubmitInProgress || this.validationInProgress)) {
				return;
			}
			let namesOfCurrentIteration = [];
			// for(let item of this.localFormData.entries()) {
			// 	console.log(item);
			// }

			if (this.form && this.form.fields) {
				this.form.fields.forEach(field => {
					let key = this.proxyFieldName(field.name);

					if (field.multiple) {
						key = this.proxyFieldName(field.name.replace('[]', ''));
					}
					if (!field.value) {
						field.value = '';
					}
					if (field.type === 'file' || field.type === 'avatar') {
						//очистка полей для файлов от старых значений
						for (let item of this.localFormData.entries()) {
							let isfoundInSavedFileKeys = false;
							for (let j = 0; j < this.savedFileKeys.length; j++) {
								if (item[0].indexOf(this.savedFileKeys[j]) > -1) {
									isfoundInSavedFileKeys = true;
									break;
								}
							}
							if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
								this.localFormData.delete(item[0]);
							}
						}

						if(field.typeContent === 'image') {
							if(this.localFormData.has(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]')) {
								this.localFormData.delete(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]')
							}
							if(field?.main) {
								this.localFormData.append(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]', field.main);
							} else if(this.form.mainImageKey) {
								this.localFormData.append(this.proxyFieldName(field.name) + '[MAIN_IMAGE_KEY]', this.form.mainImageKey);
							}
						}
						// обработка файлов происходит в fileInput / fileRemove
						// здесь ничего делать не нужно
						/*
						 _.each(field.value, (fileListItem) => {
						 this.localFormData.append(field.name, fileListItem.file, fileListItem.name)
						 });
						 */
					} else {
						// для отправки файлов придется держать в памяти неизменный localFormData
						// перед отправкой нужно удалить старые значения из localFormData
						// т.к. localFormData.append добавляет новые значения к существующим
						// а localFormData.set не позволила бы работать с массивами типа NAME[]

						// this.localFormData.keys().forEach(key => this.localFormData.delete(key))


						if (namesOfCurrentIteration.indexOf(key) < 0) {
							this.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}

						if(field.type === 'schedule') {
							field.value.forEach((item, index) => {
								Object.entries(item).forEach(([key, val]) => {
									if(Array.isArray(item[key])) {
										item[key].forEach((value, valueIndex) => {
											this.localFormData.append(`${this.proxyFieldName(field.name)}[${index}][${key}][${valueIndex}]`, value);
										})
									} else {
										this.localFormData.append(`${this.proxyFieldName(field.name)}[${index}][${key}]`, item[key]);
									}
								})
							})
							return;
						}

						if (Array.isArray(field.value)) {
							field.value.forEach((val, index) => {
								if(field?.type === 'translate' || field?.type === 'map') {
									Object.entries(val).forEach(([objectKey, objectValue]) => {
										if (namesOfCurrentIteration.indexOf(`${key}[${index}][${objectKey}]`) < 0) {
											this.localFormData.delete(`${key}[${index}][${objectKey}]`);
											namesOfCurrentIteration.push(`${key}[${index}][${objectKey}]`);
										}
										this.localFormData.append(`${key}[${index}][${objectKey}]`, objectValue)
									})

								} else {
									if (namesOfCurrentIteration.indexOf(`${key}[${index}]`) < 0) {
										this.localFormData.delete(`${key}[${index}]`);
										namesOfCurrentIteration.push(`${key}[${index}]`);
									}
									this.localFormData.append(`${key}[${index}]`, val);

								}
							});
						} else if(field?.type === 'translate' || field?.type === 'map') {
							Object.entries(field.value).forEach(([objectKey, objectValue]) => {
								if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}]`) < 0) {
									this.localFormData.delete(`${key}[${objectKey}]`);
									namesOfCurrentIteration.push(`${key}[${objectKey}]`);
								}

								this.localFormData.append(`${key}[${objectKey}]`, objectValue)

							})
						} else if(field?.type && typeof field.value === 'object') {
							Object.entries(field.value).forEach(([objectKey, objectValue]) => {

								if(!Array.isArray(objectValue) && typeof objectValue !== 'object') {
									if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}]`) < 0) {
										this.localFormData.delete(`${key}[${objectKey}]`);
										namesOfCurrentIteration.push(`${key}[${objectKey}]`);
									}

									this.localFormData.append(`${key}[${objectKey}]`, objectValue)
								}

								if(Array.isArray(objectValue)) {
									for(let i = 0; i < objectValue.length; i++) {
										if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}][${objectValue}][${i}]`) < 0) {
											this.localFormData.delete(`${key}[${objectKey}][${i}]`);
											namesOfCurrentIteration.push(`${key}[${objectKey}][${i}]`);
										}

										this.localFormData.append(`${key}[${objectKey}][${i}]`, objectValue[i])

									}
								}

								if(!Array.isArray(objectValue) && typeof objectValue === 'object'){
									Object.entries(objectValue).forEach(([objKey, objValue]) => {

										if(Array.isArray(objValue)) {
											for(let i = 0; i < objValue.length; i++) {
												if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}][${objKey}][${i}]`) < 0) {
													this.localFormData.delete(`${key}[${objectKey}][${objKey}][${i}]`);
													namesOfCurrentIteration.push(`${key}[${objectKey}][${objKey}][${i}]`);
												}

												this.localFormData.append(`${key}[${objectKey}][${objKey}][${i}]`, objValue[i])

											}
										} else {

											if (namesOfCurrentIteration.indexOf(`${key}[${objectKey}][${objKey}]`) < 0) {
												this.localFormData.delete(`${key}[${objectKey}][${objKey}]`);
												namesOfCurrentIteration.push(`${key}[${objectKey}][${objKey}]`);
											}

											this.localFormData.append(`${key}[${objectKey}][${objKey}]`, objValue)
										}
									})
								}
							})

						} else {

							this.localFormData.append(key, field.value);

						}
					}
				});
			}


			// галереи объявления: наследованные фото/видео из проекта + порядок (этап 2).
			// каждое галерейное поле шлёт своё состояние в свой ключ (AD_GALLERY / AD_VIDEOS).
			if (this.form && Array.isArray(this.form.fields)) {
				this.localFormData.delete('state[form][AD_GALLERY]');
				this.localFormData.delete('state[form][AD_VIDEOS]');
				this.form.fields.forEach((f) => {
					if (f && f.galleryValue && f.galleryKey) {
						this.localFormData.set('state[form][' + f.galleryKey + ']', JSON.stringify(f.galleryValue));
					}
				});
			}

			const validateWhileUploading = requestedAction === 'submit' && this.hasPendingManagedUploads;
			const requestAction = validateWhileUploading ? 'validate' : requestedAction;
			this.localFormData.set('state[action]', requestAction);
			if (options.triggerField) {
				this.localFormData.set('state[triggerField]', options.triggerField);
			}
			this.localFormData.set('bxajaxid', this.form.bxajaxid);
			if (this.form?.vip5Reservation?.token) {
				this.localFormData.set('vip5_reservation_token', this.form.vip5Reservation.token);
			} else {
				this.localFormData.delete('vip5_reservation_token');
			}

			if(this.currentTabId) {
				this.localFormData.set('activeTabId', this.currentTabId);
			}

			if (this.confirmed || this.forceConfirmed) {
				this.localFormData.set('confirmed', 1);
			} else {
				this.localFormData.delete('confirmed');
			}
			let requestData = this.localFormData;
			if (requestAction === 'validate') {
				requestData = this.cloneFormData(this.localFormData, {excludeFiles: true});
			} else if (requestAction !== 'submit') {
				requestData = this.cloneFormData(this.localFormData, {excludeFiles: true, excludeStageTokens: true});
			}

			if (requestAction === 'submit') {
				this.finalSubmitInProgress = true;
				this.finalUploadProgress = 0;
				this.finalUploadText = this.form?.uploadStatus?.saving || 'Saving the ad…';
			}
			if (requestAction === 'validate') {
				this.validationInProgress = true;
				this.pendingSubmitRequested = validateWhileUploading;
			}

			this.dataLoad({
				url: this.form.remote,
				data: requestData,
				delay: true,
				trackUploadProgress: requestAction === 'submit',
				timeout: 180000,
				onUploadProgress: (progress) => {
					this.finalUploadProgress = progress;
				},
				onUploadComplete: () => {
					this.finalUploadProgress = 100;
					this.finalUploadText = this.form?.uploadStatus?.saving || 'Saving the ad…';
				},
				onSuccess: (data) => {
					if (requestedAction === 'submit' && this.responseHasErrors(data)) {
						this.notifyValidationErrors(data);
					}
					if (requestAction === 'submit') {
						this.finalSubmitInProgress = false;
						this.finalUploadProgress = 0;
					}
					if (requestAction === 'validate') {
						this.validationInProgress = false;
						if (this.responseHasErrors(data)) {
							this.pendingSubmitRequested = false;
						} else if (this.pendingSubmitRequested) {
							if (this.hasPendingManagedUploads) {
								controller.addNotification({
									notificationText: this.form?.uploadStatus?.waiting || 'Wait until all files have finished uploading.'
								});
							} else {
								this.pendingSubmitRequested = false;
								this.submit();
							}
						}
					}
				},
				onError: () => {
					if (requestAction === 'submit') {
						this.finalSubmitInProgress = false;
						this.finalUploadProgress = 0;
					}
					if (requestAction === 'validate') {
						this.validationInProgress = false;
						this.pendingSubmitRequested = false;
					}
					this.notifyUploadError(this.form?.uploadStatus?.networkError);
				}
			}, requestAction === 'validate' ? {validationOnly: true} : undefined);

			// Передаём действие родителю: v-auth запускает WebOTP для первой
			// отправки и повторного запроса кода. fetch уже создан, но сервер ещё
			// не успевает отправить SMS, поэтому ожидание OTP начинается вовремя.
			this.$emit('form-submited', options);
		},

		fieldChanged(field) {
			if (field.autosubmit && !this.validationInProgress && !this.finalSubmitInProgress) {
				this.submit({action: 'autosubmit', triggerField: field.name});
			}
			this.autofillComplexName(field);
		},

		// Автоподстановка названия комплекса в поле complex_name при выборе комплекса
		// (RESIDENTIAL_COMPLEX). Заполняем только если поле пустое; при "Freestanding"
		// (комплекс не выбран) — не трогаем.
		fillComplexName(complexField) {
			if (!complexField || !this.form || !Array.isArray(this.form.fields)) return;
			const target = this.form.fields.find(f => f.code === 'complex_name');
			if (!target || target.value) return;
			const selected = (complexField.options || []).find(o => String(o.value) === String(complexField.value));
			if (selected && selected.text) {
				target.value = selected.text;
			}
		},

		autofillComplexName(field) {
			if (field && field.code === 'RESIDENTIAL_COMPLEX') {
				this.fillComplexName(field);
			}
		},

		autofillComplexNameInitial() {
			if (!this.form || !Array.isArray(this.form.fields)) return;
			const complexField = this.form.fields.find(f => f.code === 'RESIDENTIAL_COMPLEX');
			if (complexField && complexField.value) {
				this.fillComplexName(complexField);
			}
		},

		// async getFileFromUrl(url, type, name){
		// 	let response = await fetch(url);
		// 	let data = await response.blob();
		// 	let metadata = {
		// 		type: type
		// 	};
		// 	return new File([data], name, metadata);
		// },

		async fileInput(field, e) {
			// Managed files are staged immediately; the final form contains tokens only.
			this.localFiles[field.name] = e.target.files;

			for (let i = 0; i < e.target.files.length; i++) {
				const file = e.target.files[i];
				const {key = uniqueId()} = file;
				this.savedFileKeys.push(key);

				const fieldKey = `${this.proxyFieldName(field.name)}[${key}]`;
				const isBrowserFile = typeof File !== 'undefined' && file instanceof File;
				if (field.fileValidation && isBrowserFile) {
					this.enqueueManagedUpload(field, file, key);
				} else {
					this.localFormData.set(fieldKey, file.path || file);
				}
			}

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit', triggerField: field.name });
			}
		},

		fileRemove(field, e) {
			if(Array.isArray(e)) {
				if(e[1] === 'avatar') {
					this.localFormData.append(this.proxyFieldName(field.name) + '[' + e[0].key + ']', '');
				}
			} else {
				const fieldKey = `${this.proxyFieldName(field.name)}[${e.key}]`;
				this.localFormData.delete(fieldKey);
				const id = this.getStagedFileId(field.name, e.key);
				const task = this.stagedFiles[id];
				if (task) {
					task.cancelled = true;
					if (task.token) this.releaseStagedUpload(task.token);
					delete this.stagedFiles[id];
				}
			}

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit', triggerField: field.name});
			}
		},

		valueRemove(field, e) {
			// remove error of removed value
			if (field.errors && field.errors.length) {
				field.errors.splice(e, 1);
			}
		}
	}
};
</script>
